import { useEffect } from 'react';

const RedirectToEtsy = () => {
  useEffect(() => {
    window.location.href = 'https://antiquewhite.art';
  }, []);

  return null; // The component doesn't need to render anything
};

export default RedirectToEtsy;
